<template>
  <div class="widget-conversations">
    <div style="width: fit-content">
      <button
        class="button-tertiary"
        @click="$emit('create')"
      >
        <i class="bi bi-plus-lg" /> 
        New Conversation
      </button>
    </div>
    <div class="sections">
      <div
        v-for="(section, index) in sections"
        :key="index"
        class="section"
      >
        <label
          v-if="section.name"
          class="label--xsmall"
        >
          {{ section.name }}
        </label>
        <CalicoHistory 
          v-for="chat in section.chats"
          :key="chat.id"
          class="title-chat body--medium"
          :prompt="chat.title"
          @click="$emit('open', chat.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CalicoHistory from '@/components/calico/history/index.vue'

export default {
  name: 'ConversationsWidget',
  components: {
    CalicoHistory
  },
  props: {
    chats: {
      type: Array,
      default: () => [],
      required: true
    },
  },
  data() {
    return {
      sections: []
    }
  },
  watch: {
    chats: {
      handler(newChats) {
        if (newChats?.length) {
          const sections = [{
            name: '',
            days: 0,
            chats: []
          }, {
            name: 'Yesterday',
            days: 1,
            chats: []
          }, {
            name: 'Previous 7 Days',
            days: 7,
            chats: []
          }, {
            name: 'Previous 30 Days',
            days: 30,
            chats: []
          }, {
            name: '30+ Days',
            chats: []
          }]
          newChats.forEach(chat => {
            const diffTime = Math.floor((new Date() - new Date(chat.updatedAt)) / (1000 * 60 * 60 * 24));
            const sectionIndex = sections.findIndex(section => diffTime <= section.days)
            if (sectionIndex != -1) {
              const sectionChats = sections[sectionIndex].chats
              sections[sectionIndex].chats = [...sectionChats, chat]
            } else {
              sections[sections.length - 1].chats.push(chat)
            }
          })
        
          this.sections = sections.filter(section => section.chats.length)
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.widget-conversations {
  @include stack-space($space-medium);
  button {
    color: $color-black;
  }
  .sections {
    @include stack-space($space-medium);
    .section {
      @include stack-space($space-small);
      label {
        color: $color-text-secondary;
      }
    }
  }
}
</style>
